import { createWebHistory, createRouter } from "vue-router";
import DifferentialLiberationSection from "../views/DifferentialLiberationSection.vue";

import FluidsDataStudioTwo from "../views/FluidsDataStudioTwo.vue";
import ConstantCompositionExpansion from "../views/ConstantCompositionExpansion";
import MultiStageSeparatorTest from "../views/MultiStageSeparatorTest";
import CvdTest from "../views/CvdTest";
import OilViscosity from "../views/OilViscosity";
import Composition from "../views/Composition";
import SampleValidation from "../views/SampleValidation";
import SampleInformation from "../views/SampleInformation.vue";
import store from "@/store";

import QAQCIndex from "../views/QAQC/index.vue";
import QAQCDetailView from "../views/QAQC/DetailView.vue";
import QAQCOverview from "../views/QAQC/Overview.vue";
import AIMLModelling from "../views/AIMLModelling/AIMLModelling";
import DataInputs from "../views/AIMLModelling/DataInputs";
import UploadReports from "../views/AIMLModelling/UploadReports";
import SelectData from "../views/AIMLModelling/SelectData";
import DataPreview from "../views/AIMLModelling/DataPreview";
import AIMLModels from "../views/AIMLModelling/AIMLModels";
import SupervisedMLModels from "../views/AIMLModelling/SupervisedMLModels";
import FluidsdataAIModel from "../views/AIMLModelling/FluidsdataAIModel";
import BlackOilTable from "../views/AIMLModelling/BlackOilTable";
import SelectedPVTReport from "../views/AIMLModelling/SelectedPVTReport";
import FullPVTReport from "../views/AIMLModelling/FullPVTReport";
import ManualDataEntry from "../views/AIMLModelling/ManualDataEntry";

import Assets from "../views/SingleSampleFlow/Assets";
import Fields from "../views/SingleSampleFlow/Fields";
import Wells from "../views/SingleSampleFlow/Wells";
import Samples from "../views/SingleSampleFlow/Samples";
import OilTest from "../views/SingleSampleFlow/OilTest";
import GasTest from "../views/SingleSampleFlow/GasTest";

import Login from "../views/Auth/Login"

import DataInventoryAnalysis from "../views/ExploratoryDataAnalysis/DataInventoryAnalysis";
import DataExploration from "../views/DataExploration";
import CompositionChart from "../views/ExploratoryDataAnalysis/CompositionChart";
import CorrelationAnalysis from "../views/ExploratoryDataAnalysis/CorrelationAnalysis";
import CorrelationCoefficient from "../views/ExploratoryDataAnalysis/CorrelationCoefficient";
import FluidsdataInsight from "../views/ExploratoryDataAnalysis/FluidsdataInsight";
import EDADashboard from "../views/ExploratoryDataAnalysis/EDADashboard.vue";
import PVTPrediction from "../views/PVTPrediction.vue";
import axios from 'axios';
import Main from "../views/Dashboard/Main"
import Board from "../views/Dashboard/Board"

import DashboardList from "../views/DashboardNew/List"
import DashboardView from "../views/DashboardNew/View"
import DashboardCreate from "../views/DashboardNew/Create"
import DashboardEdit from "../views/DashboardNew/Edit"
import UsersModule from "../views/users/index.vue"
import RolesModuel from "../views/roles/index.vue"
import fluidsdatapal from "../views/Fluidsdatapal/index.vue"
import AgenticDashboard from "../views/AgenticDashboard/index.vue"

import { getTenantPrefix, resolveTenantIdFromBrowser } from "../utils/tenant";
const TOKEN_EXPIRY_GRACE_SECONDS = 30;

function normalizeRouterPath(path) {
  if (!path) return "";
  const trimmed = String(path).replace(/\/+$/, "");
  return trimmed === "" ? "/" : trimmed;
}

function resolveTenantIdForNavigation() {
  const fromBrowser = resolveTenantIdFromBrowser();
  if (fromBrowser) return fromBrowser;
  const selected = store.getters["tenantId/getSelectedTenant"]?.ID;
  if (selected != null && String(selected).trim() !== "") {
    return String(selected);
  }
  return null;
}

const decodeBase64Url = (value) => {
  const base64 = value.replace(/-/g, "+").replace(/_/g, "/");
  const padded = base64 + "=".repeat((4 - (base64.length % 4)) % 4);
  return decodeURIComponent(
    atob(padded)
      .split("")
      .map((char) => `%${char.charCodeAt(0).toString(16).padStart(2, "0")}`)
      .join("")
  );
};

const isTokenExpired = (token) => {
  try {
    const parts = token.split(".");
    if (parts.length < 2) return true;
    const payload = JSON.parse(decodeBase64Url(parts[1]));
    if (!payload?.exp || typeof payload.exp !== "number") return false;
    const nowInSeconds = Math.floor(Date.now() / 1000);
    return payload.exp <= nowInSeconds + TOKEN_EXPIRY_GRACE_SECONDS;
  } catch (error) {
    return true;
  }
};

const hasValidAuthToken = () => {
  const authToken = localStorage.getItem("authToken");
  if (!authToken) {
    return false;
  }
  if (isTokenExpired(authToken)) {
    store.commit("tenantId/LOGOUT", undefined, { root: true });
    return false;
  }
  return true;
};

const guest = (to, from, next) => {
  if (!hasValidAuthToken()) {
    if (to.path !== "/login") return next("/login");
    return next();
  }
  let tenantFromUrl = getTenantPrefix();
  if (!tenantFromUrl || tenantFromUrl === "login") {
    tenantFromUrl = resolveTenantIdFromBrowser();
  }
  if (!tenantFromUrl || tenantFromUrl === "login") {
    const selected = store.getters["tenantId/getSelectedTenant"]?.ID;
    if (selected != null && String(selected).trim() !== "") {
      tenantFromUrl = String(selected);
    }
  }
  if (!tenantFromUrl || tenantFromUrl === "login") {
    if (to.path !== "/login") return next("/login");
    return next();
  }
  return next(`/${tenantFromUrl}/data-management`);
};
const auth = (to, from, next) => {
  if (!hasValidAuthToken()) {
    if (to.path !== "/login") return next("/login");
    return next();
  }

  const tenantPrefix = to.params?.tenantPrefix || getTenantPrefix();
  if (!tenantPrefix) {
    store.commit("tenantId/LOGOUT", undefined, { root: true });
    if (to.path !== "/login") return next("/login");
    return next();
  }

  return next();
};

const routes = [
  {
    path: "/",
    beforeEnter: guest,
    redirect: "/login",
  },
  {
    path: "/login",
    name: "Login",
    beforeEnter: guest,
    component: Login
  },
  {
    path: `/:tenantPrefix/assets/:asset/:field/:well/:sampleId?/dltest/:id`,
    name: "DifferentialLiberationSection",
    beforeEnter: auth,
    component: DifferentialLiberationSection,
  },
  {
    path: `/:tenantPrefix/Fluidsdata-studio`,
    name: "FluidsDataStudioTwo",
    beforeEnter: auth,
    component: FluidsDataStudioTwo,
  },

  {
    path: `/:tenantPrefix/assets/:asset/:field/:well/:sampleId?/ccetest/:id`,
    name: "ConstantCompositionExpansion",
    beforeEnter: auth,
    component: ConstantCompositionExpansion,
  },
  {
    path: `/:tenantPrefix/assets/:asset/:field/:well/:sampleId?/separatortest/:id`,
    name: "MultiStageSeparatorTest",
    beforeEnter: auth,
    component: MultiStageSeparatorTest,
  },
  {
    path: `/:tenantPrefix/assets/:asset/:field/:well/:sampleId?/viscositytest/:id`,
    name: "OilViscosity",
    beforeEnter: auth,
    component: OilViscosity,
  },
  {
    path: `/:tenantPrefix/assets`,
    name: "Assets",
    beforeEnter: auth,
    component: Assets,
  },
  {
    path: `/:tenantPrefix/assets/:asset`,
    name: "Fields",
    beforeEnter: auth,
    component: Fields,
  },
  {
    path: `/:tenantPrefix/assets/:asset/:field`,
    name: "Wells",
    beforeEnter: auth,
    component: Wells,
  },
  {
    path: `/:tenantPrefix/assets/:asset/:field/:well/:sampleId?`,
    name: "Samples",
    beforeEnter: auth,
    component: Samples,
  },
  {
    path: `/:tenantPrefix/oilTest`,
    name: "OilTest",
    beforeEnter: auth,
    component: OilTest,
  },
  {
    path: `/:tenantPrefix/gasTest`,
    name: "GasTest",
    beforeEnter: auth,
    component: GasTest,
  },
  {
    path: `/:tenantPrefix/assets/:asset/:field/:well/:sampleId?/compositiontests/:id`,
    name: "Composition",
    beforeEnter: auth,
    component: Composition,
  },
  {
    path: `/:tenantPrefix/assets/:asset/:field/:well/samplevalidation/:sampleId`,
    name: "SampleValidation",
    beforeEnter: auth,
    component: SampleValidation,
  },
  {
    path: `/:tenantPrefix/assets/:asset/:field/:well/:sampleId?/sampleinformation/:sampleId`,
    name: "SampleInformation",
    beforeEnter: auth,
    component: SampleInformation,
  },
  {
    path: `/:tenantPrefix/assets/:asset/:field/:well/:sampleId?/cvdtest/:id`,
    name: "CvdTest",
    beforeEnter: auth,
    component: CvdTest,
  },
  {
    path: `/:tenantPrefix/ai-ml-modelling`,
    name: "AIMLModelling",
    beforeEnter: auth,
    component: AIMLModelling,
  },
  {
    path: `/:tenantPrefix/ai-ml-modelling/define-inputs`,
    name: "DataInputs",
    beforeEnter: auth,
    component: DataInputs,
  },
  {
    path: `/:tenantPrefix/ai-ml-modelling/define-inputs/upload-reports`,
    name: "UploadReports",
    beforeEnter: auth,
    component: UploadReports,
  },
  {
    path: `/:tenantPrefix/ai-ml-modelling/define-inputs/select-from-database`,
    name: "SelectData",
    beforeEnter: auth,
    component: SelectData,
  },
  {
    path: `/:tenantPrefix/ai-ml-modelling/define-inputs/data-preview`,
    name: "DataPreview",
    beforeEnter: auth,
    component: DataPreview,
  },
  {
    path: `/:tenantPrefix/ai-ml-modelling/define-inputs/data-preview/ai-ml-models`,
    name: "AIMLModels",
    beforeEnter: auth,
    component: AIMLModels,
  },
  {
    path: `/:tenantPrefix/ai-ml-modelling/define-inputs/upload-reports/Supervisod-ml-models/support-vector-regression`,
    name: "SupervisedMLModels",
    beforeEnter: auth,
    component: SupervisedMLModels,
  },
  {
    path: `/:tenantPrefix/ai-ml-modelling/define-inputs/upload-reports/Fluidsdata-ai-model`,
    name: "FluidsdataAIModel",
    beforeEnter: auth,
    component: FluidsdataAIModel,
  },
  {
    path: `/:tenantPrefix/ai-ml-modelling/define-inputs/upload-reports/Supervisod-ml-models/support-vector-regression/black-oil-table`,
    name: "BlackOilTable",
    beforeEnter: auth,
    component: BlackOilTable,
  },
  {
    path: `/:tenantPrefix/ai-ml-modelling/define-inputs/upload-reports/Supervisod-ml-models/support-vector-regression/selected-pvt-report`,
    name: "SelectedPVTReport",
    beforeEnter: auth,
    component: SelectedPVTReport,
  },
  {
    path: `/:tenantPrefix/ai-ml-modelling/define-inputs/upload-reports/Supervisod-ml-models/support-vector-regression/full-pvt-report`,
    name: "FullPVTReport",
    beforeEnter: auth,
    component: FullPVTReport,
  },
  {
    path: `/:tenantPrefix/ai-ml-modelling/define-inputs/upload-reports/Fluidsdata-ai-model/black-oil-table`,
    name: "FluidsdataBlackOilTable",
    beforeEnter: auth,
    component: BlackOilTable,
  },
  {
    path: `/:tenantPrefix/ai-ml-modelling/define-inputs/upload-reports/Fluidsdata-ai-model/selected-pvt-report`,
    name: "FluidsdataSelectedPVTReport",
    beforeEnter: auth,
    component: SelectedPVTReport,
  },
  {
    path: `/:tenantPrefix/ai-ml-modelling/define-inputs/upload-reports/Fluidsdata-ai-model/full-pvt-report`,
    name: "FluidsdataFullPVTReport",
    beforeEnter: auth,
    component: FullPVTReport,
  },
  {
    path: `/:tenantPrefix/ai-ml-modelling/define-inputs/manual-data-entry`,
    name: "ManualDataEntry",
    beforeEnter: auth,
    component: ManualDataEntry,
  },

  {
    path: `/:tenantPrefix/data-management`,
    name: "DataManagement",
    beforeEnter: auth,
    component: DataExploration,
  },
  {
    path: `/:tenantPrefix/fluidsIntelligence`,
    name: "fluidsdatapal",
    beforeEnter: auth,
    component: fluidsdatapal,
  },
  {
    path: `/:tenantPrefix/pvt-prediction`,
    name: "PVTPrediction",
    beforeEnter: auth,
    component: PVTPrediction,
  },

  {
    path: `/:tenantPrefix/qaqc`,
    name: "QAQCIndex",
    beforeEnter: auth,
    component: QAQCIndex,
  },
  {
    path: `/:tenantPrefix/qaqc/overview`,
    name: "QAQCOverview",
    beforeEnter: auth,
    component: QAQCOverview,
  },
          {
          path: `/:tenantPrefix/qaqc/detail/:well/sample/:sampleId/:fluidSampleID`,
          name: "QAQCDetailSample",
          beforeEnter: auth,
          component: QAQCDetailView,
        },
        {
          path: `/:tenantPrefix/qaqc/detail/:well/report/:sampleId/:reportIdentifier`,
          name: "QAQCDetailReport",
          beforeEnter: auth,
          component: QAQCDetailView,
        },
        {
          path: `/:tenantPrefix/qaqc/detail/:well?`,
          name: "QAQCDetailView",
          beforeEnter: auth,
          component: QAQCDetailView,
        },
        {
          path: `/:tenantPrefix/qaqc/test/`,
          name: "QAQCTestRedirect",
          beforeEnter: auth,
          redirect: (to) => ({
            path: `/${to.params.tenantPrefix}/qaqc/detail`,
            query: to.query,
          }),
        },
        {
          path: `/:tenantPrefix/qaqc/test/:sampleId/:testType/:testId`,
          name: "UnifiedTestView",
          beforeEnter: auth,
          component: () => import("../components/layout/QAQC/UnifiedTestView.vue"),
        },

  {
    path: `/:tenantPrefix/data-inventory-analysis`,
    name: "DataInventoryAnalysis",
    beforeEnter: auth,
    component: DataInventoryAnalysis,
  },
  {
    path: `/:tenantPrefix/EDA/data-inventory-analysis/Compositon-chart`,
    name: "CompositionChart",
    beforeEnter: auth,
    component: CompositionChart,
  },
  {
    path: `/:tenantPrefix/PVT-Properties`,
    name: "CorrelationAnalysis",
    beforeEnter: auth,
    component: CorrelationAnalysis,
  },
  {
    path: `/:tenantPrefix/EDA/correlation-analysis/PVT-Properties/correlation-coefficient`,
    name: "CorrelationCoefficient",
    beforeEnter: auth,
    component: CorrelationCoefficient,
  },
  {
    path: `/:tenantPrefix/Fluidsdata-insights`,
    name: "FluidsdataInsight",
    beforeEnter: auth,
    component: FluidsdataInsight,
  },
  {
    path: `/:tenantPrefix/exploratory-data-analysis/:analysis`,
    name: "EDADashboard",
    beforeEnter: auth,
    component: EDADashboard,
  },
  {
    path: `/:tenantPrefix/Visualization-&-Dashboards`,
    name: "Main",
    beforeEnter: auth,
    component: Main,
  },
  {
    path: `/:tenantPrefix/Visualization-&-Dashboards/:name`,
    name: "Board",
    beforeEnter: auth,
    component: Board,
  },
  {
    path: `/:tenantPrefix/Dashboards`,
    name: "DashboardList",
    beforeEnter: auth,
    component: DashboardList,
  },
  {
    path: `/:tenantPrefix/Dashboards/view`,
    name: "DashboardView",
    beforeEnter: auth,
    component: DashboardView,
  },
  {
    path: `/:tenantPrefix/Dashboards/create`,
    name: "DashboardCreate",
    beforeEnter: auth,
    component: DashboardCreate,
  },
  {
    path: `/:tenantPrefix/Dashboards/edit/:name`,
    name: "DashboardEdit",
    beforeEnter: auth,
    component: DashboardEdit,
  },
  {
    path: `/:tenantPrefix/users`,
    name: "UsersModule",
    beforeEnter: auth,
    component: UsersModule,
  },
  {
    path: `/:tenantPrefix/roles`,
    name: "RolesModule",
    beforeEnter: auth,
    component: RolesModuel,
  },
  {
    path: `/:tenantPrefix/agentic-dashboard`,
    name: "AgenticDashboard",
    beforeEnter: auth,
    component: AgenticDashboard,
  },
  {
    path: `/:tenantPrefix/agentic-dashboard/all`,
    name: "AgenticDashboardAll",
    beforeEnter: auth,
    component: AgenticDashboard,
  },
  {
    path: `/:tenantPrefix/agentic-dashboard/starred`,
    name: "AgenticDashboardStarred",
    beforeEnter: auth,
    component: AgenticDashboard,
  },
  {
    path: `/:tenantPrefix/agentic-dashboard/shared`,
    name: "AgenticDashboardShared",
    beforeEnter: auth,
    component: AgenticDashboard,
  },
  {
    path: `/:tenantPrefix/agentic-dashboard/:dashboardName`,
    name: "AgenticDashboardView",
    beforeEnter: auth,
    component: AgenticDashboard,
  },
  {
    path: `/:tenantPrefix/:catchAll(.*)`,
    name: "NotFound",
    component: () => import("../views/NotFound/NotFound.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.name !== "Login" && to.name !== "NotFound") {
    const firstSeg = to.path.split("/").filter(Boolean)[0];
    if (firstSeg && firstSeg !== "login") {
      localStorage.setItem("lastView", to.fullPath);
    }
  }
  if (to.name === "Board") {
    localStorage.setItem("lastVisitedDashboard", to.fullPath);
  }

  if (to.matched.length === 0 && to.name !== "Login") {
    const tenantId = resolveTenantIdForNavigation();
    if (tenantId) {
      const segments = to.path.split("/").filter(Boolean);
      const rest =
        segments.length > 0 && segments[0] === tenantId
          ? segments.slice(1)
          : segments;
      let rebuilt =
        rest.length > 0
          ? `/${tenantId}/${rest.join("/")}`
          : null;
      if (!rebuilt) {
        const lastView = localStorage.getItem("lastView");
        if (lastView && String(lastView).startsWith("/")) {
          const lastSeg = String(lastView).split("?")[0].split("/").filter(Boolean);
          if (lastSeg[0] === tenantId && lastSeg.length > 1) {
            rebuilt = String(lastView).split("?")[0];
          }
        }
      }
      if (!rebuilt) {
        rebuilt = `/${tenantId}/data-management`;
      }
      const nTo = normalizeRouterPath(to.path);
      const nRebuilt = normalizeRouterPath(rebuilt);
      if (nRebuilt !== nTo) {
        return next({
          path: rebuilt,
          query: to.query,
          hash: to.hash,
          replace: true,
        });
      }
    }
  }

  next();
});

export default router;